import React from "react"
import icon from "../assets/icon.jpg"
import logo from "../assets/Akruti_logo.jpg"
import call from "../assets/call.png"
import mail from "../assets/mail.png"
function Footer() {
  return (
    <div className="mt-16 w-full px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px] pb-8 lg:pb-10 footer-color">
      <div className="footer-container ">
        <div className="flex flex-col  custom-flex-row justify-around">
          <div className="left-column lg:w-1/2">
            <div className="flex items-center">
              <div className="w-[40px] md:w-[50px] lg:w-[50px] flex-shrink-0">
                <a
                  href="https://www.google.com/maps/dir//akruti+concept+studio/@18.6501975,73.7374203,13z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bc2b9db49fa449d:0xeb56e15999ec437e!2m2!1d73.7786199!2d18.6501207?entry=ttu"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={icon} alt="icon" />
                </a>
              </div>
              <div className="text-sm sm:text-lg lg:text-xl text-left tracking-wide">
                <a
                  href="https://www.google.com/maps/dir//akruti+concept+studio/@18.6501975,73.7374203,13z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bc2b9db49fa449d:0xeb56e15999ec437e!2m2!1d73.7786199!2d18.6501207?entry=ttu"
                  target="_blank"
                  rel="noreferrer"
                >
                  <h4 className="pl-7">Siddeshwar Classic Apartments, 32, Akurdi Chikhali Rd, Akurdi Gaothan, Dattawadi, Akurdi, Pimpri-Chinchwad</h4>
                  <span className="pl-7">Maharashtra 411035, Pune, India</span>
                </a>
              </div>
            </div>
            <div className="flex items-center mt-5">
              <div className="w-[40px] md:w-[50px] lg:w-[50px]">
                <img src={call} alt="icon" />
              </div>
              <div className="text-sm sm:text-lg lg:text-xl">
                <h4 className="pl-7">+91 8605616555</h4>
              </div>
            </div>
            <div className="flex items-center mt-5">
              <div className="w-[40px] md:w-[50px] lg:w-[50px]">
                <img src={mail} alt="icon" />
              </div>
              <div className="text-sm sm:text-lg lg:text-xl tracking-wide">
                <a
                  href="mailto:akruticoncept@gmail.com"
                  className=" italic text-white pl-7"
                >
                  email: akruticoncept@gmail.com
                </a>
              </div>
            </div>
          </div>
          <div className="right-column mt-5 custom-margin ">
            <div className="flex items-center justify-center custom-justify-start">
              <img
                className="w-full h-auto max-h-[120px] max-w-[100px] object-fit flex-shrink-0 "
                src={logo}
                alt="company logo"
              />
            </div>
            <div className="text-center lg:text-left mt-4">
              <span className="font-leading text-align-bottom copyright-class">
                COPYRIGHT Akruti 2023
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
